export default {
      id: "one-half-usage",
      viewBox: "0 0 266 245",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#one-half",
      toString: function () {
        return this.url;
      }
    }